import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChartCompareHorizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-compare-horizontal"} maskId="square-filled-radius-0-stroke-1-IconChartCompareHorizontal"><path d="M4 20H21V21H3V3H4V20Z" fill="currentColor"/><path d="M10 18H5V17H10V18Z" fill="currentColor"/><path d="M18 15H5V14H18V15Z" fill="currentColor"/><path d="M12 10H5V9H12V10Z" fill="currentColor"/><path d="M16 7H5V6H16V7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChartCompareHorizontal;
